<template>
  <base-modal
    :id="modalId"
    :ok-handler="okHandler"
    :title="title"
    :ok-button-text="okButtonText"
    :ok-button-class="okButtonClass"
  >
    <div>
      <p>The recipient <strong>{{ recipMessage }}</strong> may be duplicated in your list or another organization's list. Would you still like to add this recipient? (If so, this recipient will be flagged in your system with contact information of the organization with whom they may be in conflict).</p>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';

export default {
  name: 'DuplicateWarningModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: 'Duplicate recipient detected',
    },
    content: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'ADD RECIPIENT',
    },
    okButtonClass: {
      type: String,
      default: 'btn-warning',
    }
  },
  data() {
    return {
      modalId: 'duplicate-warning-modal',
    }
  },
  computed: {
    recipMessage: function() {
      let recipObj = this.$store.getters.getRecipToCreate || {};
      if (recipObj[0]) {
        let userFirstName = recipObj[0].firstName;
        let userLastName = recipObj[0].lastName;
        return userFirstName + ' ' + userLastName;
      }
      return '';
    },
    recipToCreate: function()  {
      return this.$store.getters.getRecipToCreate;
    }
  },
  methods: {
    okHandler: function() {
      const payload = {
        vm: this,
        recips: this.recipToCreate,
      };
      this.$store.dispatch('createRecipient', payload);
      this.$store.dispatch('clearRecipState');
    },
  },
}
</script>
